// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5076":"d1e891da","5702":"08bf88fe"}[chunkId] + ".chunk.css";
};